import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries"]
  static values = {
    insuranceRates: Array // Changed from regulatorySettings
  }

  connect() {
    // Initialize with existing insurance rates
    this.insuranceRatesValue.forEach(rate => {
      this.addRow(rate);
    });
  }

  add(event) {
    event.preventDefault();
    this.addRow();
  }

  addRow(data = {}) {
    const template = document.querySelector('#insurance-rate-template').content.cloneNode(true);
    const entry = this.initializeTemplateWithData(template, data);
    this.entriesTarget.appendChild(entry);
  }

  initializeTemplateWithData(template, data) {
    const container = template.firstElementChild;
    container.querySelector('input[name*="[id]"]').value = data.id || this.generateUniqueId();
    // container.querySelector('input[name*="[short_name]"]').value = data.name || '';
    // container.querySelector('input[name*="[base_valuation]"]').value = data.base_valuation || '0.60';
    // container.querySelector('input[name*="[valuation_charge]"]').value = data.valuation_charge || '6.00';
    // container.querySelector('input[name*="[deductible]"]').value = data.deductible || '';
    // container.querySelector('input[name*="[coverage_limit]"]').value = data.coverage_limit || '';
    // container.querySelector('textarea[name*="[notes]"]').value = data.notes || '';
    // container.querySelector('input[name*="[include_in_bol]"]').checked = data.include_in_bol || false;




    return template;
  }

  removeRow(event) {
    event.preventDefault();
    if (confirm("Are you sure you want to remove this insurance rate?")) {
      event.target.closest('.insurance-rate-entry').remove();
    }
  }

  generateUniqueId() {
    return Math.random().toString(36).substring(2, 8);
  }
}